export const firebaseConfig = {
  apiKey: "AIzaSyBDE668k7bjxsG_RYnYr-wFbGdyYdgYHbE",
  authDomain: "bancodelagua-app.firebaseapp.com",
  projectId: "bancodelagua-app",
  storageBucket: "bancodelagua-app.firebasestorage.app",
  messagingSenderId: "44260869719",
  appId: "1:44260869719:web:bb256b5a3b65297fee8512",
  measurementId: "G-7P4VEE1G1B"
};